import React, { useEffect, useState } from "react";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import { Btn } from "../../AbstractElements";

interface OptionItem {
  id: number;
  label: string;
}

interface DualListboxProps {
  DualListLabel?: string;
  leftOptions: OptionItem[];
  onSelectionChange?: (selectedItems: OptionItem[]) => void;
  value?: number | string | any;
  disabled?:boolean,
  styleLeftContaianer?:React.CSSProperties,
  styleRightContaianer?:React.CSSProperties,
  listStyleLeft?:React.CSSProperties,
  listStyleRight?:React.CSSProperties
}

const DualListBox: React.FC<DualListboxProps> = ({
  DualListLabel,
  leftOptions,
  onSelectionChange,
  value,
  disabled = false,
  styleLeftContaianer,
  styleRightContaianer,
  listStyleLeft,
  listStyleRight
}) => {

  const [leftSearchValue, setLeftSearchValue] = useState("");
  const [rightSearchValue, setRightSearchValue] = useState("");
  
  const { leftListt, rightListt } = React.useMemo(() => {
    if (value?.length > 0) {
      return {
        leftListt: leftOptions?.filter((item) => !value.includes(item.id)),
        rightListt: leftOptions?.filter((item) => value.includes(item.id)),
      };
    }
    return { leftListt: leftOptions, rightListt: [] };
  }, [value, leftOptions]);

  const [leftList, setLeftList] = useState(leftListt);
  const [rightList, setRightList] = useState(rightListt);


  const handleSelectionChange = (updatedRightList: OptionItem[]) => {
    if (onSelectionChange) {
      onSelectionChange(updatedRightList);
    }
  };
  useEffect(() => {
    setLeftList(leftListt);
    setRightList(rightListt);
  }, [leftListt, rightListt]);
 

  const filteredLeftList = leftList.filter((item) =>
    item.label.toLowerCase().includes(leftSearchValue.toLowerCase())
  );

  const filteredRightList = rightList.filter((item) =>
    item.label.toLowerCase().includes(rightSearchValue.toLowerCase())
  );

  const moveAllToRight = () => {
    const newRightList = [...rightList, ...leftList];
    setRightList(newRightList);
    setLeftList([]);
    handleSelectionChange(newRightList);
  };

  const moveAllToLeft = () => {
    setLeftList([...leftList, ...rightList]);
    setRightList([]);
    handleSelectionChange([]);
  };

  const moveToRight = (item: OptionItem) => {
    const newRightList = [...rightList, item];
    console.log("itemmmmmm", item);
    console.log("rightList", rightList);
    console.log("newRightList", newRightList);
    setRightList(newRightList);
    setLeftList(leftList.filter((i) => i.id !== item.id));
    handleSelectionChange(newRightList);
  };

  const moveToLeft = (item: OptionItem) => {
    const newRightList = rightList.filter((i) => i.id !== item.id);
    setLeftList([...leftList, item]);
    setRightList(newRightList);
    handleSelectionChange(newRightList);
  };

  return (
    <div>
      <label
        style={{
          fontWeight: "500",
          marginBottom: "6px",
          display: "block",
          marginTop: "10px",
        }}
      >
        {DualListLabel}
      </label>
      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        {/* Left List */}
        <div
          style={{
            border: "1px solid #ddd",
            padding: "10px",
            width: "200px",
            height: "150px",
            ...styleLeftContaianer,
          }}
        >
          <input
            type="text"
            placeholder="Search..."
            style={{
              width: "100%",
              marginBottom: "10px",
              // backgroundColor: "transparent",
              backgroundColor: "#fff",
              border: "1px solid transparent",

            }}
            onChange={(e) => setLeftSearchValue(e.target.value)}
            value={leftSearchValue}
            disabled={disabled}
          />
          <div style={{ height: "100px", overflowY: "auto",...listStyleLeft }}>
            {filteredLeftList.map((item) => (
              <div
                key={item.id}
                style={{
                  padding: "6px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
                // onClick={() => moveToRight(item)}
                onClick={() => !disabled && moveToRight(item)} // Disable clicking
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>

        {/* Transfer Buttons */}
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <Btn
            style={{
              display: "flex",
              justifyContent: "center",
              backgroundColor: "#43B9B2",
              color: "white",
              padding: "5px",
            }}
            disabled={disabled ||leftList.length === 0}
            onClick={moveAllToRight}
          >
            <FaLongArrowAltRight />
          </Btn>
          <Btn
            style={{
              display: "flex",
              justifyContent: "center",
              backgroundColor: "#43B9B2",
              color: "white",
              padding: "5px",
            }}
            disabled={disabled ||rightList.length === 0}
            onClick={moveAllToLeft}
          >
            <FaLongArrowAltLeft />
          </Btn>
        </div>

        {/* Right List */}
        <div
          style={{
            border: "1px solid #ddd",
            padding: "10px",
            width: "200px",
            height: "150px",
           ...styleRightContaianer
          }}
        >
          <input
            type="text"
            placeholder="Search..."
            style={{
              width: "100%",
              marginBottom: "10px",
              // backgroundColor: "transparent",
              backgroundColor: "#fff",
              border: "1px solid transparent",
            }}
            onChange={(e) => setRightSearchValue(e.target.value)}
            value={rightSearchValue}
            disabled={disabled} // Disable search input

          />
          <div style={{ height: "100px", overflowY: "auto" ,...listStyleRight}}>
            {filteredRightList.map((item) => (
              <div
                key={item.id}
                style={{
                  padding: "6px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
                onClick={() => !disabled  && moveToLeft(item)}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualListBox;